import React from 'react'

import EezeeAds from '../components/eezee-ads'

class EezeeAdsPage extends React.Component {
    render(){
        
        return (
            <div>
                <EezeeAds/>
            </div>
        )
    }
}

export default EezeeAdsPage


// WEBPACK FOOTER //
// ./src/containers/eezee-ads-page.js